




























































































import {Component, Ref, Vue} from 'vue-property-decorator'
import {Inject} from "typescript-ioc";
import Pagination from '@/component/Pagination/index.vue'
import DeleteDialog from "@/component/Crud/delete-dialog.vue";
import CreateDialog from "@/component/Crud/create-dialog.vue";
import RefreshButton from "@/component/Button/refresh-button.vue";
import PaginationTable from "@/component/Table/pagination-table.vue";
import CompanyBook from "@/model/CompanyBook";
import {PqForm} from "biz-ts/src/api/Paging";
import CompanyBookApi from "@/api/CompanyBookApi";
import CompanyLocation from "@/model/CompanyLocation";
import {Event} from "@/event/Event";
import ExportRentalLogDialog from "@/view/book-manage/book/export-rental-log-dialog.vue";

@Component({
    components: {
        ExportRentalLogDialog,
        Pagination,
        DeleteDialog,
        CreateDialog,
        RefreshButton,
        PaginationTable,
    },
})
export default class BookView extends Vue {

    @Inject
    private cbookApi!: CompanyBookApi

    @Ref()
    private ptable!: PaginationTable

    @Ref()
    private deleteDialog!: DeleteDialog

    @Ref()
    private exportDialog!: ExportRentalLogDialog

    private cbook = new CompanyBook()

    private pqForm = this.initPqForm()

    private initPqForm(): PqForm {
        const pqFormJson = this.$route.query.pqForm as string | null
        if (pqFormJson != null)
            return JSON.parse(pqFormJson)
        else
            return new PqForm()
    }

    private mounted() {
        this.$bus.$on(Event.COMPANY_LOCATION_CHANGE, (clocation: CompanyLocation) => {
            this.refresh()
        })
    }

    private refresh() {
        this.ptable?.refresh()
    }

    private async getPaging() {
        return this.cbookApi.paging(this.pqForm)
    }

    private async handleDetailClick(cbook: CompanyBook) {
        this.$redirector.bookDetail({
            id: cbook.id.toString(),
            pqForm: JSON.stringify(this.pqForm)
        })
    }

    private async handleDeleteClick(cbook: CompanyBook) {
        this.cbook = cbook
        this.deleteDialog.open()
    }

    private async deleteBook() {
        await this.cbookApi.delete(this.cbook.id)
    }

    private get contentHeight() {
        return window?.innerHeight - 240
    }

    private renterFmt(cbook: CompanyBook) {
        if (cbook.rentals.length == 0) return null
        return cbook.rentals[0].user.name
    }

    private rentalDurationFmt(cbook: CompanyBook) {
        if (cbook.rentals.length == 0) return null
        return cbook.rentals[0].duration
    }
}
